// Which mailbox the Charter Mail page talks to.
//
// The agent workflow and the Outlook connection are independent, and only one of them is interesting
// to prove. This picks between them behind one identical interface, so the page never knows which it
// is using and nothing else has to change when you switch.
//
//   mock  — a fake mailbox seeded with charter inquiries and ordinary noise, plus controls to send a
//           test inquiry and to reply as the customer. No Azure, no Microsoft account.
//   graph — the real thing: delegated Microsoft Graph against your own Outlook mailbox.
//
// IMPORTANT: "mock" fakes ONLY the mail transport. The flow, the LLM extraction, the gap detection
// and the composed reply are identical and run against a real ECAP session, so a workflow that works
// in mock mode works over Outlook.
//
// Selection, in order: a ?mail=mock|graph query override (handy for a demo machine), then
// REACT_APP_KRAPF_MAIL_PROVIDER, then automatic — Graph if a client id is configured, else mock.
import * as graph from './graphMail';
import * as mock from './mockMail';

export const MOCK = 'mock';
export const GRAPH = 'graph';

export function selectedProvider() {
  try {
    const q = new URLSearchParams(window.location.search).get('mail');
    if (q === MOCK || q === GRAPH) return q;
  } catch (e) { /* no window */ }
  const env = String(process.env.REACT_APP_KRAPF_MAIL_PROVIDER || '').trim().toLowerCase();
  if (env === MOCK || env === GRAPH) return env;
  return String(process.env.REACT_APP_KRAPF_GRAPH_CLIENT_ID || '').trim() ? GRAPH : MOCK;
}

export function isMock() {
  return selectedProvider() === MOCK;
}

/** The mail client for this session. Same shape either way. */
export function mail() {
  return isMock() ? mock : graph;
}

/** Mock-only test controls. Empty object under Graph, so callers can branch on isMock() alone. */
export function harness() {
  return isMock()
    ? { injectInquiry: mock.injectInquiry, replyAsCustomer: mock.replyAsCustomer, resetMailbox: mock.resetMailbox }
    : {};
}
